export default class Foundation {

    constructor() {

        this.$modal = document.querySelector('.foundation__modal');
        this.$secArray = [...this.$modal.querySelectorAll('.foundation__sec')];
        this.current = 0;
        this.activateSec = () => this.$secArray[this.current].classList.add('-active');
        this.deactivateSec = () => this.$modal.querySelector('.-active').classList.remove('-active');
        this.lastIndex = this.$secArray.length - 1;

        this.init();

    }

    init() {

        // モーダルのイベントを追加
        this.addModal();

        // ナビゲーションのイベントを追加
        this.addNav();

    }

    addModal() {

        const $about = document.getElementById('about'),
            $openArray = [...$about.querySelectorAll('.about__open button')],
            $close = this.$modal.querySelector('.foundation__close');

        $openArray.forEach(($open, i) => {
            $open.addEventListener('click', () => {
                this.$modal.classList.add('-active');
                this.current = i;
                this.activateSec();
            });
        });

        $close.addEventListener('click', () => {
            this.$modal.classList.remove('-active');
            this.deactivateSec();
        });

    }

    addNav() {

        const $navArray = [...this.$modal.querySelectorAll('.foundation__nav button')];

        $navArray.forEach($nav => {
            $nav.addEventListener('click', e => this.setNav(e));
        });

    }

    setNav(e) {

        this.current += e.currentTarget.classList.contains('-next') ? 1 : -1;

        if (this.current > this.lastIndex) {
            this.current = 0;
        } else if (0 > this.current) {
            this.current = this.lastIndex;
        }

        this.deactivateSec();
        this.activateSec();

    }

}